import axios, { AxiosResponse } from "axios";
import { Branch, BranchHours } from "../types/branch";

export default class BranchesApi {
  static getBranches(reasonId?: number): Promise<Branch[]> {
    const reqUrl = reasonId !== undefined ? `/api/Branches?reasonId=${reasonId}` : "/api/Branches";
    return axios
      .get(reqUrl)
      .then(
        (response: AxiosResponse): Branch[] => {
          return response.data;
        }
      )
      .catch(error => {
        throw error;
      });
  }

  static async getAllBranchHours(): Promise<BranchHours[]> {
    try {
      const response = await axios.get<BranchHours[]>("/api/Branches/AllBranchHours");
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}
